import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

/** Fires a Plausible pageview on every SPA route change. */
export function usePageViews() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(window.location.origin + location.pathname + location.search);
  }, [location.pathname, location.search]);
}
